import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { signInWithGooglePopup, signOutUser, auth } from '../../utils/firebase.utils'; 
import './Header.css';
import { firestore } from '../../utils/firebase.utils';
import { collection, getDocs } from "firebase/firestore";

const Header = ({ user, setUser }) => {
  const [showLogout, setShowLogout] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const showBackArrow = location.pathname === '/analyze';

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userRef = collection(firestore, 'users');
        const userSnapshot = await getDocs(userRef);
        const userDoc = userSnapshot.docs.find((doc) => doc.id === currentUser.uid);
        if (userDoc) {
          console.log('User tokens:', userDoc.data().tokens);
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, [setUser]);

  const handleSignIn = async () => {
    await signInWithGooglePopup();
  };

  const handleLogout = async () => {
    await signOutUser();
    setUser(null); 
    setShowLogout(false); 
  };

  const handleBuyTokens = () => {
    navigate('/buy-tokens');
  };

  return (
    <header className="header">
      <div className="header-left">
        {user && (
          <div className="welcome-message">
            <span className="user-name"  onClick={() => setShowLogout(!showLogout)}>Hi, {user?.displayName?.split(" ")[0]}</span>
          </div>)}
            {showLogout && (
              <div className="logout-dropdown">
                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
        
        {showBackArrow && (
          <ArrowLeftOutlined
            className="back-arrow"
            onClick={() => navigate('/')}
          />
        )}
      </div>

      <div className="logo-container">
        <img
          src="logo.png"
          alt="Next Level Tutors"
          className="logo"
          onClick={() => navigate('/')}
        />
      </div>

      <div className="user-section">
        {user ? (
          <div className="user-info">
            <div className="token-info">
              <button className="buy-tokens-button" onClick={handleBuyTokens}>
                Buy More Tokens
              </button>
            </div>
          </div>
        ) : (
          <button className="login-button" onClick={handleSignIn}>
            Sign In With Google
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
